import { Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CampaignsTable from '../components/tables/campaigns-table';
// import CampaignFilter from '../components/filters/campaign-filter';

const CampaignsListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="کمپین ها"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}
    />
    {/* <CampaignFilter onFinish={setFitlers} /> */}
    <CampaignsTable filters={filters} />
  </>);
}

export default CampaignsListRoute;
